/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartMakeOfferButton_item$ref = any;
export type CartMakeOfferButton_item = {
    readonly serviceId: string | null;
    readonly ecommerceTrackingParams: unknown | null;
    readonly " $refType": CartMakeOfferButton_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartMakeOfferButton_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "ecommerceTrackingParams",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'be6112663d55fd7c0e0b11960597de2f';
export default node;
